import type { z } from 'zod';

import { assessmentSchema } from '@/_containers/assessment/shared';

export const practiceExamSchema = assessmentSchema.omit({
  questions: true,
  last_attempt: true,
  // allow_go_back: true,
  // show_feedback: true,
  // show_correct_answer: true,
  // force_submitanswer_before_question_change: true,
});

export type PracticeExamSchema = z.infer<typeof practiceExamSchema>;

export type PurchasedPracticeExamSchema = PracticeExamSchema;
